// TinyMCE is self-hosted under /tinymce/. First call injects the script;
// subsequent calls (mounts + idle preload) share the same promise.

let scriptPromise = null;

export function loadTinyMceScript() {
  if (typeof window === 'undefined') return Promise.resolve();
  if (window.tinymce) return Promise.resolve();
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[src*="tinymce/tinymce"]');
    if (existing) {
      const start = Date.now();
      const timer = setInterval(() => {
        if (window.tinymce) {
          clearInterval(timer);
          resolve();
        } else if (Date.now() - start > 10_000) {
          clearInterval(timer);
          scriptPromise = null;
          reject(new Error('TinyMCE script load timeout'));
        }
      }, 50);
      return;
    }
    const script = document.createElement('script');
    script.src = '/tinymce/tinymce.min.js';
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      scriptPromise = null;
      reject(new Error('TinyMCE script failed to load'));
    };
    document.head.appendChild(script);
  });

  return scriptPromise;
}

export function preloadTinyMceOnIdle() {
  if (typeof window === 'undefined') return;
  if (window.tinymce || scriptPromise) return;
  const schedule = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
  schedule(
    () => {
      loadTinyMceScript().catch(() => {});
    },
    { timeout: 4000 }
  );
}
